/* eslint-disable eqeqeq */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route, Redirect } from 'react-router';
import { HashRouter, Switch } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { EventoServer } from '@cgn/framework-ui-components/v1';
import App from './App';
import Sezioni from './Messaggi/Sezioni';
import RedirectHandler from './Shared/RedirectHandler';
import reducers from './Redux/reducers';
import { SignalREventiServerProvider } from './Shared/EventiServer/EventiServerContext';

EventoServer.connettiSignalR(window.IdUtente);

// if (window.Promise == null) {
//     window.Promise = require("core-js/fn/promise");
// }

if (window.IdCanale != 0) {
  window.location.href = `#/messaggi/comunicazioni/${window.IdCanale}`;
}

const store = createStore(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

const container = document.getElementById('appContainer');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <SignalREventiServerProvider>
      <HashRouter>
        <Switch>
          <App>
            <Route exact path="/" component={() => <Redirect to="/messaggi/quesiti/aperti" />} />
            <Route path="/ufficio/:codiceUfficio" component={RedirectHandler} />
            <Route path="/messaggi" component={Sezioni} />
          </App>
        </Switch>
      </HashRouter>
    </SignalREventiServerProvider>
  </Provider>,
);
